import { render, staticRenderFns } from "./commentTag.vue?vue&type=template&id=a8b20096"
import script from "./commentTag.vue?vue&type=script&lang=js"
export * from "./commentTag.vue?vue&type=script&lang=js"
import style0 from "./commentTag.vue?vue&type=style&index=0&id=a8b20096&prod&lang=less&scopde=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports